import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import BlurTextField from 'components/connectedForm/BlurTextField';
import ToggleButtonInput from '../../connectedForm/ToggleButtonInput/ToggleButtonInput';
import { setExpandedRow } from '../../../state/modules/app/actions';
import getIn from '../../connectedForm/utils/getIn';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import mapStateToRowProps from '../../../utils/mapStateToRowProps';

const DropdownToggle = styled.div`
  position: absolute;
  right: 5px;
  top: 2px;
`;

const Table = styled.div`
  display: table;
`;

const Cell = styled.div`
  display: table-cell;
`;

const Row = styled.div`
  display: table-row;
`;

const Header = styled.header`
  display: table-row;
  border-bottom: 1px solid black;
`;

class ArrayFormatter extends Component {
  constructor(props) {
    super();

    this.expanded = getIn(props, `expandedRows.${props.rowIdx}.expanded`);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const willBeExpanded = getIn(nextProps, `expandedRows.${nextProps.rowIdx}.expanded`);

    return nextProps.value !== this.props.value || willBeExpanded !== this.expanded;
  }

  componentDidUpdate() {
    this.expanded = getIn(this.props, `expandedRows.${this.props.rowIdx}.expanded`);
  }

  render() {
    const expanded = getIn(this.props, `expandedRows.${this.props.rowIdx}.expanded`);
    const dispatch = getIn(this.props, 'column.dispatch');

    const values = expanded
      ? this.props.value.map((value) => {
          return this.renderRow(value);
        })
      : this.renderRow(this.props.value[0]);

    const dropdown = (
      <DropdownToggle>
        <ToggleButtonInput
          value={!expanded}
          onChange={(checked) => {
            dispatch(
              setExpandedRow(this.props.rowIdx, {
                expanded: !checked,
                rowHeight: !checked ? (this.props.value.length + 1) * 35 : 35,
              })
            );
          }}
          checkedLabel={'Expand'}
          uncheckedLabel={'Hide'}
        />
      </DropdownToggle>
    );

    return (
      <Fragment>
        <Table>
          {values.length > 1 ? this.renderHeader() : null}
          {values}
        </Table>
        {this.props.value.length > 1 ? dropdown : null}
      </Fragment>
    );
  }

  renderHeader() {
    return (
      <Header>
        <Cell>
          <BlurTextField value={'Price'} includeLabel={false} readOnly={true} />
        </Cell>
        <Cell>
          <BlurTextField value={'Break'} includeLabel={false} readOnly={true} />
        </Cell>
        <Cell>
          <BlurTextField value={'Value'} includeLabel={false} readOnly={true} />
        </Cell>
        <Cell>
          <BlurTextField value={'Origin'} includeLabel={false} readOnly={true} style={{ width: '50%' }} />
        </Cell>
      </Header>
    );
  }

  renderRow(rowData) {
    // let {labelField, valueField} = this.props.dependentValues.options;
    return (
      <Row>
        <Cell>
          <BlurTextField value={rowData.description} includeLabel={false} readOnly={true} />
        </Cell>
        <Cell>
          <BlurTextField value={rowData.sellingPriceBreak} includeLabel={false} readOnly={true} />
        </Cell>
        <Cell>
          <BlurTextField value={rowData.sellingPrice} includeLabel={false} readOnly={true} />
        </Cell>
        <Cell>
          <BlurTextField
            value={rowData.priceOriginDescription}
            includeLabel={false}
            readOnly={true}
            style={{ width: '50%' }}
          />
        </Cell>
      </Row>
    );
  }
}

export default compose(connect(mapStateToRowProps))(ArrayFormatter);
